import { PlusCircle } from "@phosphor-icons/react";

import RestrictedComponent from "common/components/RestrictedComponent";
import { Button } from "common/components/ui/Button";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "common/components/ui/Tooltip";
import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import useAppStore from "common/hooks/useAppStore";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

export default function CreateCampaign() {
  const isDesktop = useTwBreakpoint("lg");
  const { accounts_count: accountsCount } = useSelectedWorkspaceContext();

  const setIsCampaignModalOpen = useAppStore(
    (state) => state.setIsCampaignModalOpen,
  );

  const hasAccounts = accountsCount > 0;

  const buttonComponent = (
    <Button
      data-intercom-target="create-campaign-button"
      onClick={() => setIsCampaignModalOpen(true)}
      disabled={!hasAccounts}
      leftIcon={<PlusCircle weight="fill" />}
      size={isDesktop ? "sm" : "md"}
      className="only:flex-1"
    >
      Create campaign
    </Button>
  );

  const finalComponent = hasAccounts ? (
    buttonComponent
  ) : (
    <Tooltip>
      <TooltipTrigger asChild>{buttonComponent}</TooltipTrigger>
      <TooltipContent>
        You must connect a LinkedIn account before creating a campaign
      </TooltipContent>
    </Tooltip>
  );

  return (
    <RestrictedComponent visibleFor={["campaigns_full"]}>
      {finalComponent}
    </RestrictedComponent>
  );
}
